import { render, staticRenderFns } from "./constructionDetail.vue?vue&type=template&id=d72ab1ea&scoped=true&"
import script from "./constructionDetail.vue?vue&type=script&lang=js&"
export * from "./constructionDetail.vue?vue&type=script&lang=js&"
import style0 from "./constructionDetail.vue?vue&type=style&index=0&id=d72ab1ea&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d72ab1ea",
  null
  
)

export default component.exports